/**
 * Action filters
 *
 * Keep in mind that actions filters are complex, and this isn't the only component that renders them. Make sure you check how changes to methods that return TemplateResults will affect action filters inside loops.
 */

// Import dependencies
import { AutomatorTemplateActionFilterBase } from './_base';
import { unsafeCSS, css } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-template-filter' )
export class AutomatorActionFilter extends AutomatorTemplateActionFilterBase {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;
}
